import {colors} from 'shells/colors/colors';
import {ChatbotRegularAiIcon} from 'shells/icon/svg/chatbot-regular-ai-icon';
import {Stack} from 'shells/layout/stack/stack';
import {AiBadge} from 'shells/summary/ai-badge';
import {Body} from 'shells/typography/body';

interface Props {
    dateRange: string;
}

export function AiSectionHeader(props: Props) {
    return (
        <Stack isHorizontal={true} justifyContent='space-between'>
            <Stack isHorizontal={true} spacing={4} alignItems='center'>
                {/* @ts-expect-error */}
                <ChatbotRegularAiIcon size={20} fill={colors.aiPurplePrimary} />
                <Body isBold={true} color='ai-purple' size='small'>
                    Chatbot summary for {props.dateRange}
                </Body>
            </Stack>
            <AiBadge />
        </Stack>
    );
}
